export default [
  // Chorus 2 - 2:23

  // {m:73, t: 1, pos: 4}, // OFF
  {m:73, t: 2, pos: 4},
  {m:73, t: 3, pos: 3},
  {m:73, t: 4, pos: 2},
  {m:73, t: 5, pos: 5},
  {m:73, t: 6, pos: 2},
  {m:73, t: 7, pos: 4},
  {m:73, t: 8, pos: 2},

  // {m:74, t: 1, pos: 4}, // OFF
  {m:74, t: 2, pos: 3},
  {m:74, t: 3, pos: 2},
  {m:74, t: 4, pos: 1},
  {m:74, t: 5, pos: 5},
  {m:74, t: 6, pos: 3},
  {m:74, t: 7, pos: 4},
  {m:74, t: 8, pos: 3},

  {m:75, t: 1, pos: 1},
  {m:75, t: 2, pos: 4},
  {m:75, t: 3, pos: 2},
  {m:75, t: 4, pos: 1},
  {m:75, t: 5, pos: 5},
  {m:75, t: 6, pos: 2},
  {m:75, t: 7, pos: 4},
  {m:75, t: 8, pos: 2},

  {m:76, t: 1, pos: 1},
  {m:76, t: 2, pos: 4},
  {m:76, t: 3, pos: 2},
  {m:76, t: 4, pos: 1},
  {m:76, t: 5, pos: 5},
  {m:76, t: 6, pos: 2},
  {m:76, t: 7, pos: 4},
  {m:76, t: 8, pos: 2},

  // {m:77, t: 1, pos: 4}, // OFF
  {m:77, t: 2, pos: 4},
  {m:77, t: 3, pos: 3},
  {m:77, t: 4, pos: 2},
  {m:77, t: 5, pos: 5},
  {m:77, t: 6, pos: 2},
  {m:77, t: 7, pos: 4},
  {m:77, t: 8, pos: 2},

  // {m:78, t: 1, pos: 4}, // OFF
  {m:78, t: 2, pos: 3},
  {m:78, t: 3, pos: 2},
  {m:78, t: 4, pos: 1},
  {m:78, t: 5, pos: 5},
  {m:78, t: 6, pos: 3},
  {m:78, t: 7, pos: 4},
  {m:78, t: 8, pos: 3},

  {m:79, t: 1, pos: 4},
  {m:79, t: 2, pos: 3, hold: 15}, {m:79, t: 2, pos: 5, hold: 15},
  // {m:79, t: 3, pos: 2},
  // {m:79, t: 4, pos: 1},
  // {m:79, t: 5, pos: 5},
  // {m:79, t: 6, pos: 3},
  // {m:79, t: 7, pos: 4},
  // {m:79, t: 8, pos: 3},

  // m:80 holding

];



//////////////////
// WEBPACK FOOTER
// ./lib/songs/song_chorus_2.js
// module id = 14
// module chunks = 0